import { Avatar, Tooltip, Typography } from "antd";
import type { UserLimitedList } from "../../app/generated-axios-client";
import { palette } from "../../app/theme";

const AVATAR_PALETTE = [
  palette.dashBlue,
  palette.dashGreen,
  palette.dashOrange,
  palette.dashPurple,
  palette.dashCyan,
  palette.dashRed,
];

function getInitials(user: UserLimitedList): string {
  const first = user.first_name?.trim();
  const last = user.last_name?.trim();
  if (first && last) return (first[0] + last[0]).toUpperCase();
  if (first) return first.slice(0, 2).toUpperCase();
  if (last) return last.slice(0, 2).toUpperCase();
  return user.username.slice(0, 2).toUpperCase();
}

function getDisplayName(user: UserLimitedList): string {
  const parts = [user.first_name?.trim(), user.last_name?.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : user.username;
}

type Props = {
  assignees: UserLimitedList[];
};

export const AssigneeAvatarGroup = ({ assignees }: Props) => {
  if (!assignees.length) {
    return <Typography.Text type="secondary">—</Typography.Text>;
  }

  return (
    <Avatar.Group max={{ count: 3 }} size="small">
      {assignees.map((user) => (
        <Tooltip key={user.id} title={getDisplayName(user)} placement="top">
          <Avatar
            size="small"
            style={{ backgroundColor: AVATAR_PALETTE[user.id % AVATAR_PALETTE.length] }}
          >
            {getInitials(user)}
          </Avatar>
        </Tooltip>
      ))}
    </Avatar.Group>
  );
};
